import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { NavbarOptions } from "@obg/mat.ui.core";
import { DeviceConfigService } from "@obg/ngx.global";

@Component({
	selector: "obg-m-otp-container",
	styleUrls: ["./otp.container.scss"],
	templateUrl: "./otp.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class OtpContainer {
	@HostBinding("class.obg-m-otp-container") hostCss = true;
	@Output() close = new EventEmitter<void>();

	hasLoaded = false;

	navbarOptions: NavbarOptions = {
		hideBackButton: true,
		showCloseButton: true,
		preventDefaultBack: false,
	};

	constructor(
		private dialogRef: MatDialogRef<OtpContainer>,
		private deviceConfigService: DeviceConfigService
	) {}

	closeDialog(): void {
		this.close.emit();
		this.dialogRef.close();
	}

	loading() {
		this.hasLoaded = true;
	}

	isDesktop() {
		return this.deviceConfigService.isDesktop();
	}
}
